const FontSize = [
    {
        text: '14', value: '14pt', callback: () => {
        }
    },
    {
        text: '16', value: '16pt', callback: () => {
        }
    },
    {
        text: '48', value: '48pt', callback: () => {
        }
    },
    {
        text: '22', value: '22pt', callback: () => {
        }
    },
]
export default FontSize;